const EventEmitter      = require('events');
let emitter             = new EventEmitter();

// $snack({
//     title: 'INFO', //{value: 'INFO', color: 'purple'}
//     message: 'Hello World',
//     buttons: [
//         'Close', // Default action is close the snack
//         {
//             title: 'Button Title',
//             cb: ()=> {}, //Call Back
//             color: 'red',
//             val: null, // A Custom Value That Is Passed Into The Callback
//         }
//     ], // Null For A default Close
//     position: 'bottom'
// })

function snack(title, message, buttons = null, timeout = null, position = null) {
    emitter.emit('showSnack', {
        title,
        message,
        buttons,
        timeout,
        position
    })
}

function info(message) {
    snack({value: 'Info', color: 'blue'}, message)
}

function error(message) {
    snack({value: 'Error', color: 'error'}, message)
}

function netWorkError() {
    snack({value: 'Error', color: 'error'}, 'Network please try again')
}

module.exports = snack
module.exports.events = emitter
module.exports.info = info
module.exports.error = error
module.exports.netWorkError = netWorkError